import React, { useEffect, useReducer, useState } from 'react';
import GameManager from '../cvp-webgames-core/GameManager';

import UIOverlay from '../components/UIOverlay';
import ReactTools from '../cvp-webgames-core/Misc/ReactTools';
import VideoEnvironment from '../cvp-webgames-core/Components/Environments/React/VideoEnvironment';
import Scenario1 from '../scenarios/scenario1/Scenario1';
import Scenario2 from '../scenarios/scenario2/Scenario2';
import { constants } from '../misc/constants';
import JsxUIManager from '../cvp-webgames-core/UI/JsxUiManager';
import ReactSoundManager from '../cvp-webgames-core/Sound/ReactSoundManager';
import { ScenariosConfig } from '../misc/interfaces';
import { getSaveData, mapDivEnterToClick, saveGame } from '../misc/tools';
import { globals } from '../misc/globals';

const reducer = (state: any, action: any) => {
	var result = ReactTools.generalReducer(state, action);
	switch (action.type) {
		case 'forceUpdate':
			result = {...state, forceUpdate: !state.forceUpdate};
			break; 
			case 'setGameManager':
				result = {...state, gameManager: action.value};
				break; 
		}
	return result;
};
 
const GamePage = (props: any) => { 
	const [forceUpdate, setForceUpdate] = useState(false);
	const [state, dispatch] = useReducer(reducer, {
		gameManager: null,
		forceUpdate: true
	});

	(window as any).onToggleMute = () => {
        globals.isMuted = !globals.isMuted;
        state.gameManager.SoundManager.mutedAudio = globals.isMuted;
        state.gameManager.environment.props.muted = globals.isMuted;
        dispatch({
            type: 'forceUpdate'
        });
    }

    (window as any).isMuted = () => {
        return globals.isMuted;
    }

    (window as any).mapDivEnterToClick = (evt: any) => {
        return mapDivEnterToClick(evt);
    }

	useEffect(() => {
		if(state.gameManager) {
			if(typeof state.gameManager.currentScenarioIndex === 'undefined' || state.gameManager.currentScenarioIndex === null || state.gameManager.currentScenarioIndex === -1) {
				state.gameManager.loadScenario(props.scenarioId);
			}

		} else {
			var gm = new GameManager();
			
			gm.customData = {
				dispatch: dispatch,
				saveData: getSaveData(),
				updateWindow: props.updateWindow,
                saveGame: (gm: GameManager) => {
                    saveGame(gm.customData.saveData);
                }
			};
			var environment = new VideoEnvironment(gm, dispatch);
			environment.init();
			gm.init([
				new Scenario1(gm, constants.scenarios.scenario1.id),
				new Scenario2(gm, constants.scenarios.scenario2.id)
			], environment, new JsxUIManager(gm), new ReactSoundManager(), true, '', {}, () => {
				dispatch({
					type: 'forceUpdate',
					value: state.gameManager
				});
			});
			dispatch({
				type: 'setGameManager',
				value: gm
			});
		}
	}, [state.gameManager, state.forceUpdate]);

	(window as any).forceUpdateCC = () => {
		dispatch({
			type: 'forceUpdate',
			value: state.gameManager
		});
	}
  
	return (
		state.gameManager ? (
			<div id="game-container" className='modal-disable-select' style={{
				width: '100%',
				height: '100%'
			}}>
				{state.gameManager.environment.render((memory: string) => {
					globals.memory = memory;

					dispatch({
						type: 'forceUpdate'
					});
				}, () => {
					dispatch({
						type: 'forceUpdate'
					});
				}, {updateWindow: props.updateWindow, shouldShowDebugBttns: () => {
                    return globals.showDebugForComponents;
                }})}
                <UIOverlay updateWindow={props.updateWindow} gameManager={state.gameManager} scenarioId={props.scenarioId} forceUpdate={() => {
					dispatch({
						type: 'forceUpdate',
						value: state.gameManager
					});
				}}></UIOverlay>
			</div>) : (<div>Initialing Page...</div>)
	);
};

export default GamePage;
